import { objUnderscore } from '@get-bridge/learn-legacy-shared/dist/utils/object';

export default function(task) {
  if (!task.assigneeId && task.assignee) {
    const assigneeId = parseInt(task.assignee.id, 10)
    task = Object.assign({}, task, { assigneeId })
  }
  task =  Object.assign({}, task, {
    completedAt: task.completedAt ? task.completedAt.toISOString() : undefined,
    dueAt: task.dueAt ? task.dueAt.toISOString() : undefined,
    createdAt: task.createdAt ? task.createdAt.toISOString() : undefined
  })

  return objUnderscore(task)
}



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/tasks/shared/formatTaskForApi.js